
import React, { useContext, useState } from 'react';
import { Space, Table, Tag, Popconfirm, Image, Input, Row, Col } from 'antd';
import { AudioOutlined, DeleteFilled, DeleteOutlined, EditOutlined, EyeOutlined, MessageOutlined, PlusCircleFilled, PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Cascader } from 'antd';
import { Button, } from 'antd';
import { ApiConfig } from '../../services/ApiConfigs';
import { ApiServices } from '../../services/apiServices';
import Search from 'antd/es/input/Search';
import MessageCmp from './MessageCmp';
import { DriverContext } from '.';
import ViewDrivers from './ViewDrivers';

const UserDataTable = () => {

    const { loading, deleteUser, userData, setViewModalOpen, setSelectedDriver, setAddModalOpen } = useContext(DriverContext)

    const [selectedValue, setSelectedValue] = useState(['0']);
    const [selectedUser, setSelectedUser] = useState([]);
    const [value, setValue] = useState('');


    const options = [
        { value: '0', label: 'Active' },
        { value: '1', label: 'Blocked' }
    ]

    const onChange = async (status, value) => {
        setSelectedValue(status[0])
    };

    const [sendMessageModal, setSendMessageModal] = useState(false);
    const [messageType, setMessageType] = useState("");

    const columns = [
        {
            title: 'Image',
            dataIndex: 'photoData',
            key: 'photoData',
            render: (image) => {
                return <Image
                    src={image?.url ? image?.url : "/image/user.png"}
                    width={60}
                    height={60}
                    style={{ borderRadius: 100 }}
                />
            }
        },
        {
            title: 'Name',
            dataIndex: 'firstName',
            key: 'firstName',
            sorter: (a, b) => (a.firstName + ' ' + a.lastName).localeCompare(b.firstName + ' ' + b.lastName),
            render: (text, record) => <a>{text + " " + record.lastName}</a>,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Address',
            dataIndex: 'address',
            key: 'address',
            render: (text) => <a>{text}</a>,
        },
        // {
        //     title: 'Available',
        //     dataIndex: 'isAvailable',
        //     key: 'isAvailable',
        //     render: (text) => <a style={{ color: text == "Offline" ? "gray" : 'green' }}>{text}</a>,
        // },
        {
            title: 'Available',
            dataIndex: 'isAvailable',
            key: 'isAvailable',
            filters: [
                { text: 'Online', value: 'Online' },
                { text: 'Offline', value: 'Offline' }
            ],
            onFilter: (value, record) => record.isAvailable === value,
            render: (text) => <span style={{ color: text === 'Offline' ? 'gray' : 'green' }}>{text}</span>,
        },
        {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Vehicle Type',
            dataIndex: 'vehicleType',
            key: 'vehicleType',
            render: (text) => <a>{text}</a>,
        },


        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Space size="middle">
                        <div onClick={() => {
                            console.log(record, "view", _)
                            setSelectedDriver(record)
                            setViewModalOpen(true)
                        }}>
                            <EyeOutlined />
                        </div>

                        <div onClick={() => {
                            setSelectedDriver(record)
                            setAddModalOpen(true)
                        }}>
                            <EditOutlined />
                        </div>

                        <Popconfirm
                            title="Delete the task"
                            description="Are you sure to delete this task?"
                            icon={
                                <QuestionCircleOutlined
                                    style={{
                                        color: 'red',
                                    }}
                                />
                            }
                            onConfirm={() => deleteUser(record.id)}
                        >
                            <DeleteOutlined />
                        </Popconfirm>

                        <div onClick={() => {
                            setMessageType(1)
                            setSendMessageModal(true)
                            setSelectedUser(record)
                        }}>
                            <MessageOutlined />
                        </div>
                    </Space >
                </Space >
            ),
        },
    ];

    const [searchData, setSearchData] = useState([]);


    return (
        <>
            <MessageCmp isModalOpen={sendMessageModal} setIsModalOpen={setSendMessageModal} type={messageType} selectedUser={selectedUser} />
            <Row style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Col span={6}>
                    <div style={{ padding: '12px 0' }}>
                        <Button onClick={() => {
                            setMessageType(0)
                            setSendMessageModal(true)
                        }} type="primary" icon={<img src='/image/messages.png' alt='...' style={{ height: 20, width: 20, objectFit: 'contain' }} />} iconPosition="start" >
                            Broadcast message
                        </Button>
                    </div>
                </Col>
                <Col>
                    <div style={{ padding: '12px 0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: 10 }}>
                        {/* <div className='mx-2'>
                            <Button type="primary" onClick={() => setAddModalOpen(true)} icon={<PlusOutlined />}>
                                Drivers
                            </Button>
                        </div> */}
                        <div>
                            <Search
                                placeholder="Search teacher"
                                enterButton
                                onChange={e => {
                                    const currValue = e.target.value.toLowerCase(); // Convert input to lowercase
                                    setValue(currValue);
                                    const filteredData = data.filter(entry =>
                                        entry.firstname.toLowerCase().includes(currValue) || entry.lastname.toLowerCase().includes(currValue)
                                    );
                                    if (currValue) {
                                        setSearchData(filteredData);
                                    } else {
                                        setSearchData([]);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
            <Table columns={columns} dataSource={value ? searchData : userData} loading={loading}
                pagination={{ defaultPageSize: 5, showSizeChanger: true, pageSizeOptions: ['10', '20', '30'] }}
            />
            <ViewDrivers />
        </>
    )
}

export default UserDataTable